import script from "./RoutesServed.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoutesServed.vue?vue&type=script&setup=true&lang=ts"

import "./RoutesServed.vue?vue&type=style&index=0&id=2fe9184a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fe9184a"]])

export default __exports__